import React from 'react'
import { Link } from 'react-router-dom'
import ObjectInspector from 'react-inspector'
import { Button, message, Tooltip, Popover, Popconfirm } from 'antd'
import moment from 'moment'
import { retryJob, cancelJob } from '../../../../services/api/apiJobs'

function JobsTableRow(props) {
    const { item = {}, loading, reset } = props || {}
    const {
        _id, number, created_by, system, service, status, retried, filename, link_download, meta, done_at, processing_at, error_at, created_at, update_at,
        error,
    } = item || {}
    const { request } = meta || {}
    const getStatusTootip = (status) => {
        let tooltipTitle = ''
        switch (status) {
            case 'success':
                tooltipTitle = moment(done_at).format('HH:mm DD/MM/YYYY')
                break;
            case 'processing':
                tooltipTitle = moment(processing_at).format('HH:mm DD/MM/YYYY')
                break;
            case 'error':
                tooltipTitle = <div>
                    {!!error &&
                        <p className='text-danger'>
                            <i class="fa fa-exclamation-circle text-danger mr-1" aria-hidden="true" />{error}
                        </p>
                    }
                    <span>{`${moment(error_at).format('HH:mm DD/MM/YYYY')}`}</span>
                </div>
                break;
            default:
                break;
        }
        return tooltipTitle
    }

    const getStatusClass = (status) => {
        let statusClass = ''
        switch (status) {
            case 'success':
                statusClass = 'badge badge-success badge-pill'
                break;
            case 'processing':
                statusClass = 'badge badge-info badge-pill'
                break;
            case 'error':
                statusClass = 'badge badge-danger badge-pill'
                break;
            default:
                statusClass = 'badge badge-secondary badge-pill'
                break;
        }
        return statusClass
    }

    const handleRetry = async (jobId) => {
        try {
            const { success, message: mess } = await retryJob(jobId)
            if (!success) {
                throw new Error(mess)
            }
            message.success(`Job đã được chạy lại.`)
            reset()
        } catch (error) {
            message.error(error.message)
        }
    }

    const handleCancelJob = async (jobId) => {
        try {
            const { success, message: mess } = await cancelJob(jobId)
            if (!success) {
                throw new Error(mess)
            }
            message.success(`Job đã được cancel.`)
            reset()
        } catch (error) {
            message.error(error.message)
        }
    }

    const disabledBtnCancelJob = loading || ['success', 'error', 'cancelled'].includes(status)

    return (
        <tr>
            <td>
                <Link to={`/jobs/${_id}`}>
                    {number}
                </Link>
            </td>
            <td>{created_by}</td>
            <td>{system}</td>
            <td>{service}</td>
            <td>
                <Popover content={getStatusTootip(status)}>
                    <div className={getStatusClass(status)} style={{ cursor: 'pointer' }}>
                        {status}
                    </div>
                </Popover>
            </td>
            <td>{retried}</td>
            <td>{moment(created_at).format('DD/MM/YYYY HH:mm')}</td>
            <td>{moment(update_at).format('DD/MM/YYYY HH:mm')}</td>
            <td>
                {link_download && filename ?
                    <a href={link_download} target='_blank'>
                        <i className="fa fa-file-excel-o mx-1" aria-hidden="true" />{filename}
                    </a> : '-'
                }
            </td>
            <td>
                {!!Object.keys(request).length ?
                    <ObjectInspector depth={0} path="root.value"
                        data={!!Object.keys(request).length ? request : '--'} /> : ''
                }
            </td>
            <td>
                <div className="Actions d-flex align-items-center">
                    <Tooltip title={`Thử lại ${retried}/10`}>
                        <Button
                            className='btnRetry p-0 m-1' type={'link'}
                            disabled={loading || (retried >= 10) || !['success', 'error'].includes(status)}
                            style={{ height: 'unset' }}
                            onClick={() => handleRetry(_id)}
                        >
                            <i className="fa fa-retweet" style={{ fontSize: 20, width: 24 }} />
                        </Button>
                    </Tooltip>
                    <Tooltip title='Chi tiết'>
                        <Link to={`/jobs/${_id}`}>
                            <Button className='btnDetail p-0 m-1' type={'link'} disabled={loading} style={{ height: 'unset' }}>
                                <i className="fa fa-info-circle" aria-hidden="true" style={{ fontSize: 20, width: 24 }}></i>
                            </Button>
                        </Link>
                    </Tooltip>
                    {
                        !!status && !['success', 'error', 'cancelled'].includes(status) &&
                        <Tooltip title='Hủy job'>
                            <Popconfirm
                                title={`Bạn có chắc chắn muốn hủy job ${number}?`}
                                placement={'topRight'}
                                okText='Có'
                                cancelText='Không'
                                disabled={disabledBtnCancelJob}
                                onConfirm={() => handleCancelJob(_id)}
                            >
                                <Button
                                    className='btnCancel p-0 m-1'
                                    type={'link'}
                                    disabled={disabledBtnCancelJob}
                                    style={{ height: 'unset' }}
                                >
                                    <i
                                        className={`fa fa-ban ${disabledBtnCancelJob ? 'text-secondary' : 'text-danger'}`}
                                        aria-hidden="true"
                                        style={{ fontSize: 20, width: 24, ...(disabledBtnCancelJob && { opacity: 0.5 }) }}
                                    />
                                </Button>
                            </Popconfirm>
                        </Tooltip>
                    }
                </div>
            </td>
        </tr>
    )
}

export default JobsTableRow